import { ElementType } from 'react';

import {
  FormHelperTextProps as MuiFormHelperTextProps,
  styled,
} from '@mui/material';
import clsx from 'clsx';

import { classNamesFor } from '../../../utils/classNames';

const classNamesFactory = classNamesFor('FormHelperText');

const classNames = {
  root: classNamesFactory.root(),
  hint: classNamesFactory.attribute('hint'),
  hintAbsolute: classNamesFactory.attribute('hintAbsolute'),
  text: classNamesFactory.element('text'),
  error: classNamesFactory.globalClassNames.error,
  disabled: classNamesFactory.globalClassNames.disabled,
};

export type DsFormHelperTextProps = MuiFormHelperTextProps<
  'p',
  {
    component?: ElementType;
    textWrapper?: ElementType;
    hintAbsolute?: boolean;
  }
>;

const HelperText = styled('div', {
  name: 'MuiFormHelperText',
  slot: 'HelperText',
  overridesResolver: ({ hintAbsolute }, styles) => {
    return [styles.text, hintAbsolute && styles.textAbsolute];
  },
  target: 'DS-FormHelperText-text',
  shouldForwardProp: (prop) => prop !== 'hintAbsolute',
})<{ hintAbsolute?: any }>({});

export const DsFormHelperText = styled(
  ({
    component,
    children,
    hintAbsolute,
    error,
    disabled,
    className,
    ...props
  }: DsFormHelperTextProps) => {
    const Root = component || 'div';
    return (
      <Root
        {...props}
        className={clsx(
          className,
          classNames.root,
          error ? classNames.error : classNames.hint,
          disabled && classNames.disabled,
          hintAbsolute && classNames.hintAbsolute
        )}
        data-testid="helper-text"
      >
        <HelperText
          className={clsx(
            classNames.text,
            hintAbsolute && classNames.hintAbsolute
          )}
          hintAbsolute={hintAbsolute}
        >
          {children}
        </HelperText>
      </Root>
    );
  },
  {
    name: 'MuiFormHelperText',
    slot: 'Root',
    skipVariantsResolver: true,
    overridesResolver: (_, styles) => {
      return [styles.root];
    },
    target: 'DS-FormHelperText-root',
  }
)({});
